import React from 'react';
import {Stage} from '../Stage';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

type CompletedStageProps = {
    date: string,
    id: string,
    title: string,
}

export const CompletedStage = (props: CompletedStageProps) => {
    const {date, id, title} = props

    return (
        <Stage
            expanded={false}
            icon={<CheckCircleOutlineIcon color="success" />}
            id={id}
            subTitle={date}
            title={title}
        />
    )
}
